var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8349 4.85474H21.733L15.4014 11.971L22.85 21.6547H17.0178L12.4498 15.7817L7.22304 21.6547H4.32316L11.0954 14.0431L3.94995 4.85474H9.93017L14.0592 10.223L18.8349 4.85474ZM17.8176 19.9489H19.4236L9.05758 6.47098H7.33431L17.8176 19.9489Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.5f7a5f5321711cf2480f3df840f8a8d9.svg";
export { ForwardRef as ReactComponent };